import { BaseResponseType } from '../cognito/authResponse.types';
import { RestaurantResponseType } from '../restaurant/restaurant.types';
import { UserRoleRelationsType } from '../user-roles/user-roles.types';
import { EmployeeType } from './employee.types';

export enum EmployeeUserRestaurantsType {
  MEAL = 'meal',
  REST = 'rest',
}

export interface UserRestaurantsBasicTypes {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
  status: string;
}
export interface UserRestaurantsType extends UserRestaurantsBasicTypes {
  user: EmployeeType;
  restaurant: RestaurantResponseType;
}

export interface CreateUserRestaurantsType {
  userId: string;
  restaurantId: number;
}
export interface GetUserRestaurantssResponseType extends BaseResponseType {
  data: UserRestaurantsType[] | null;
}
export interface CreateUserRestaurantsResponseType extends BaseResponseType {
  data: UserRestaurantsType | null;
}
export interface DeleteUserRestaurantsResponseType extends BaseResponseType {
  data: null;
}

export interface UserRestaurantRelationsTypes extends UserRestaurantsBasicTypes {
  userRoles?: UserRoleRelationsType[];
}
